<template src="./vehicledocuments.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
import GetcurrencySymbol from "@/assets/js/currency_sign.js";
var moment = require("moment");
export default {
  props: ["NewVehicle", "type"],
  components: {
    DocumentPopup,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  data() {
    return {
      currency_type : GetcurrencySymbol(),
      ImageEndpoint: Endpoints.Helper.Image + "/",
      Documents: [],
      ViewDocument: {},
      NewDocument: {},
      ShowViewDetailModel: false,
      ShowMap: false,
      DocFilter: "All",
      locationPoints: "",
      DocumentSubcategories: "",
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.GetDocumentList();
      this.GetVehicleDocumentSubcategories();
    }, 3000);
  },
  methods: {
    GetVehicleDocumentSubcategories() {
      Axios.post(Endpoints.Vehicle.DocumentSubcategories, {
        token: localStorage.getItem("token"),
        vehicle_id: this.NewVehicle.id,
      }).then((Response) => {
        if (Response.data.success) {
          this.DocumentSubcategories = Response.data.subcategories;
        }
      });
    },
    GetDocumentList() {
      var obj = {
        token: localStorage.getItem("token"),
        search_key: this.DocFilter,
      };
      if (this.type === "Asset") {
        obj.asset_id = this.NewVehicle.id;
      } else {
        obj.vehicle_id = this.NewVehicle.id;
      }
      Axios.post(Endpoints.Vehicle.Documents, obj).then((Response) => {
        if (Response.data.success) {
          this.Documents = {
            documents: Response.data.documents.data,
            page: 1,
            last_page: Response.data.documents.last_page,
          };
        }
      });
    },
    ViewDetailDocument(document) {
      this.ViewDocument = document;
      this.ShowViewDetailModel = true;
      this.ShowMap = false;
      if (
        this.ViewDocument.fields.latitude &&
        this.ViewDocument.fields.latitude.value &&
        this.ViewDocument.fields.latitude.value != "" &&
        this.ViewDocument.fields.longitude &&
        this.ViewDocument.fields.longitude.value &&
        this.ViewDocument.fields.longitude.value != ""
      ) {
        this.ShowMap = true;
        const marker = {
          lat: parseFloat(this.ViewDocument.fields.latitude.value),
          lng: parseFloat(this.ViewDocument.fields.longitude.value),
        };
        this.locationPoints = marker;
        this.infoOptions.content =
          '<div id="mapcontent"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
          this.ViewDocument.fields.vehicle.value +
          "</h1></div>";
      }

      for (const index in this.ViewDocument.fields) {
          this.ViewDocument.fields[index]["show_field"] = true;
          if (index == "miles" && this.NewVehicle.service_measurement != 'Miles') {
            this.ViewDocument.fields['miles']["show_field"] = false;
          }
          if (index == "hours" && this.NewVehicle.service_measurement != 'Hours') {
            this.ViewDocument.fields['hours']["show_field"] = false;
          }
      }

    },
    EditVehicleDocument(document) {
      this.$parent.EditDocument(document);
    },
    DeleteVehicleDocument(document_id) {
      this.$parent.DeleteDocument(document_id);
    },
    ViewMore(currentPage) {
      var nextPage = currentPage + 1;
      var obj = {
        token: localStorage.getItem("token"),
        search_key: this.DocFilter,
      };
      if (this.type === "Asset") {
        obj.asset_id = this.NewVehicle.id;
      } else {
        obj.vehicle_id = this.NewVehicle.id;
      }
      obj.page = nextPage;

      Axios.post(Endpoints.Vehicle.Documents, obj).then((Response) => {
        if (Response.data.success) {
          this.Documents.page = nextPage;
          this.Documents.last_page = Response.data.documents.last_page;
          Response.data.documents.data.forEach((element) => {
            this.Documents.documents.push(element);
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./vehicledocuments.scss";
.custom-scrollbar {
  overflow-y: scroll;
  padding-right: 10px;
  height: 250px;
}
</style>
